import { render, staticRenderFns } from "./sent67.vue?vue&type=template&id=53239740&"
import script from "./sent67.vue?vue&type=script&lang=js&"
export * from "./sent67.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports